import { makeContextModule } from '@cian/react-utils';

import { IApplicationContext } from 'shared/common/types/applicationContext';

export const {
  Context: ApplicationContext,
  useContext: useApplicationContext,
  withContext: withApplicationContext,
} = makeContextModule<IApplicationContext>({
  contextName: 'ApplicationContext',
});
